@if (visible$ | async) {
  <app-chart-tile
    [title]="'water-meter-chart-tile.title' | translate"
    [getSeries]="getSeries"
    [options]="options"
    [userTrackingPeriodOptions]="userTrackingPeriodOptions"
    >
  </app-chart-tile>
}
